import ThailandAutoComplete from 'vue-thailand-address-autocomplete'
// import api from '../../services/service_vendor'
import Swal from 'sweetalert2'
import apiMain from '../../services/service'
// import moment from 'moment'
export default {
  components: {
    ThailandAutoComplete
  },
  data () {
    return {
      title: 'จัดการข้อมูลเจ้าหนี้',
      search: '',
      currentPage: 1,
      items_perpage: 10,
      modal_active: false,
      modal_data: {
        'id': 0,
        'code': '',
        'tax_id': '',
        'name': '',
        'address': '',
        'sub_district': '',
        'district': '',
        'province': '',
        'post_code': '',
        'telephone': '',
        'credit_day': 0,
        'debt_balance': 0,
        'active_status': 0,
        'create_by': '',
        'create_time': '',
        'edit_by': '',
        'edit_time': '',
        'gender_id': null,
        'brith_date': '',
        'facebook': '',
        'line_id': ''
      },
      modal_title: '',
      data_list: [],
      header: {
        'Access-Token': this.$store.state.token
      },
      branch: 0,
      dyn_address: ''
    }
  },
  computed: {
    filterData: function () {
      let text = this.search.trim()
      return this.data_list.filter(Vendortomer => {
        return (
          Vendortomer.name.indexOf(text) > -1 || Vendortomer.code.indexOf(text) > -1
        )
      })
    },
    paginate: function () {
      this.totalItem = this.filterData.length
      if (this.currentPage >= this.totalPages) {
        this.currentPage = Math.max(0, this.totalPages - 1)
      }
      var index = (this.currentPage - 1) * this.items_perpage
      return this.filterData.slice(index, index + this.items_perpage)
    }
  },
  methods: {
    itemRender (current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    changeBranch (data) {
      console.log(data)
      this.dyn_address = data
      console.log(this.dyn_address)
      this.getAll()
    },
    onChange (pageNumber) {
      this.currentPage = pageNumber
    },
    select (address) {
      this.modal_data.sub_district = address.district
      this.modal_data.district = address.amphoe
      this.modal_data.province = address.province
      this.modal_data.post_code = address.zipcode
    },
    close_modal () {
      $('#modal_active').modal('hide')
      this.modal_data = {
        id: 0,
        code: '',
        name: '',
        credit_day: 0,
        debt_balance: 0,
        telephone: '',
        address: '',
        sub_district: '',
        district: '',
        province: '',
        post_code: '',
        gender_id: null,
        brith_date: '',
        facebook: '',
        line_id: '',
        active_status: 1
      }
    },
    editVendor (data) {
      this.modal_title = 'แก้ไขข้อมูลเจ้าหนี้'
      $('#modal_active').modal('show')
      this.modal_data = data
    },
    getAll () {
      this.$store.state.isLoading = true
      let body = {
        'keyword': '',
        'limit': 1000000,
        'status': 1
      }
      apiMain.callMisApi(
        this.dyn_address + '/' + 'vendor/v1/list/vendor',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        body,
        result => {
          if (result.response === 'success') {
            this.data_list = result.data
          } else {
            this.alert_msg('warning', 'ดึงข้อมูลเจ้าหนี้',
              result.message
            )
            Swal.fire({
              title: 'เชื่อมต่อข้อมูลสาขาไม่ได้',
              text: 'กรุณาตรวจสอบการเชื่อมต่อ',
              icon: 'warning',
              showCancelButton: false,
              confirmButtonText: 'ตกลง'
            }).then((result) => {
              if (result.value) {
                location.reload()
              }
            })
          }
          this.$store.state.isLoading = false
        },
        error => {
          this.$store.state.isLoading = false
          this.alert_msg('error', 'ไม่สามารถเข้าถึงข้อมูล',
            error.message
          )
          Swal.fire({
            title: 'เชื่อมต่อข้อมูลสาขาไม่ได้',
            text: 'กรุณาตรวจสอบการเชื่อมต่อ',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'ตกลง'
          }).then((result) => {
            if (result.value) {
              location.reload()
            }
          })
        }
      )
    },
    removeVendor (code) {
      Swal.fire({
        title: 'ลบข้อมูลเจ้าหนี้',
        text: 'ท่านต้องการลบข้อมูลเจ้าหนี้รหัส ' + code + ' ใช่หรือไม่ ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        reverseButtons: true
      }).then((result) => {
        if (result.value) {
          this.$store.state.isLoading = true
          var body = {
            'code': code,
            'active_status': 0
          }
          apiMain.callMisApi(
            this.dyn_address + '/' + 'vendor/v1/remove/vendor',
            {
              headers: {
                'Access-Token': this.branch.access_token
              }
            },
            body,
            result => {
              if (result.response === 'success') {
                this.getAll()
                this.alert_msg('success', 'ลบข้อมูลเจ้าหนี้',
                  result.message
                )
              } else {
                this.alert_msg('warning', 'ลบข้อมูลเจ้าหนี้',
                  result.message
                )
              }
              this.$store.state.isLoading = false
            },
            error => {
              this.$store.state.isLoading = false
              alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
            }
          )
        }
      })
    },
    action_modal () {
      if (this.modal_data.code === '') {
        this.addVendor()
      } else {
        this.updateVendor()
      }
    },
    addVendor () {
      this.$store.state.isLoading = true
      this.modal_data.credit_day = parseInt(this.modal_data.credit_day)
      this.modal_data.debt_limit = 0
      this.modal_data.debt_balance = parseInt(this.modal_data.debt_balance)
      this.modal_data.active_status = parseInt(this.modal_data.active_status)
      apiMain.callMisApi(
        this.dyn_address + '/' + 'vendor/v1/add/vendor',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        this.modal_data,
        result => {
          if (result.response === 'success') {
            this.getAll()
            this.alert_msg('success', 'เพิ่มข้อมูลเจ้าหนี้',
              result.message
            )
          } else {
            this.alert_msg('warning', 'เพิ่มข้อมูลเจ้าหนี้',
              result.message
            )
          }
          this.$store.state.isLoading = false
          this.close_modal()
        },
        error => {
          this.$store.state.isLoading = false
          this.alert_msg('error', 'ไม่สามารถเข้าถึงข้อมูล',
            error.message
          )
        }
      )
    },
    updateVendor () {
      this.$store.state.isLoading = true
      this.modal_data.credit_day = parseInt(this.modal_data.credit_day)
      this.modal_data.debt_limit = 0
      this.modal_data.debt_balance = parseInt(this.modal_data.debt_balance)
      this.modal_data.active_status = parseInt(this.modal_data.active_status)
      apiMain.callMisApi(
        this.dyn_address + '/' + 'vendor/v1/update/vendor',
        {
          headers: {
            'Access-Token': this.branch.access_token
          }
        },
        this.modal_data,
        result => {
          if (result.response === 'success') {
            this.getAll()
            this.alert_msg('success', 'บันทึกข้อมูลเจ้าหนี้',
              result.message
            )
          } else {
            this.alert_msg('warning', 'บันทึกข้อมูลเจ้าหนี้',
              result.message
            )
          }
          this.$store.state.isLoading = false
          this.close_modal()
        },
        error => {
          this.alert_msg('error', 'ไม่สามารถเข้าถึงข้อมูล',
            error.message
          )
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted () {
    this.checkUser()
    this.getBranch()
    setTimeout(() => {
      this.branch = this.$store.state.branch_list[0]
      this.dyn_address = this.$store.state.branch_list[0].dyn_address
      this.getAll()
    }, 1000)
    $('body').on('hidden.bs.modal', '.modal', function () {
      $(this).removeData('bs.modal')
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/vendor.js